import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger } from "@/components/ui/select";
import type { CommentSortOption } from "@roman/shared/types/Comment";
import { ChevronDown } from "lucide-react";

type SelectSortCommentProps = {
  selectedSortOption: CommentSortOption;
  setSelectedSortOption: (selectedSortOption: CommentSortOption) => void;
  className?: string;
};

const COMMENT_SORT_OPTIONS: Record<CommentSortOption, string> = {
  MOST_REPLIED_DESC: "おすすめ順",
  COMMENTED_AT_DESC: "最新順",
  COMMENTED_AT_ASC: "古い順",
  MOST_LIKED_DESC: "人気順",
};

export const SelectSortComment = ({ selectedSortOption, setSelectedSortOption, className }: SelectSortCommentProps) => {
  return (
    <Select value={selectedSortOption} onValueChange={(value: CommentSortOption) => setSelectedSortOption(value)}>
      <SelectTrigger
        className={`max-w-fit border-secondary rounded-lg text-[#0098EA] font-semibold ring-0 focus:ring-0 text-center ${className ?? ""}`.trim()}
        icon={ChevronDown}
        iconClassName="opacity-100 text-secondary w-5 h-5"
      >
        <p className="w-full text-center px-1 text-xs font-bold">{COMMENT_SORT_OPTIONS[selectedSortOption]}</p>
      </SelectTrigger>

      <SelectContent className="rounded-lg">
        <SelectGroup>
          {Object.entries(COMMENT_SORT_OPTIONS).map(([value, label]) =>
            value === "COMMENTED_AT_ASC" ? null : (
              <SelectItem key={value} value={value as CommentSortOption}>
                {label}
              </SelectItem>
            ),
          )}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};
